var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMail = function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.998 0A3.003 3.003 0 0 0 0 3v10c0 1.657 1.349 3 2.998 3h14.004A3.003 3.003 0 0 0 20 13V3c0-1.657-1.349-3-2.998-3zm-.903 2.582A1 1 0 0 1 2.998 2h14.004c.397 0 .746.238.903.582l-7.297 5.674a.98.98 0 0 1-1.216 0zM2 5.045v5.82l3.612-3.01zm.084 8.354a1 1 0 0 0 .915.601h14.004a1 1 0 0 0 .915-.601l-5.142-4.288-.939.723a2.98 2.98 0 0 1-3.672 0l-.94-.723zm15.918-2.534v-5.82l-3.612 2.81z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMail;